import { Button, Flex, Input, Skeleton, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ReusableTable from "../../../Reuseable/ReusableTable/ReusableTable";
import FilterDropdown from "../../../Reuseable/actionHeader/Filter";
import { formatCurrency } from "../../../assets/helpers";
import { fetchUserFilters } from "../../../store/filters";
import { fetchBankDashboard } from "../../../store/portfolioSlice";
import { fetchTelecallerFeedbackCases } from "../../../store/telecaller/cases";
import { CasesFeedbackModal } from "../FeedbackModal/CasesFeedback";
import AllocationFilter from "../../../Reuseable/Allocation/AllocationFilter/AllocationFilter";
import CustomFilterDropdown from "../../../Reuseable/Allocation/CustomFilterDropdown/CustomFilterDropdown";
import ExportModal from "../ExportModal/ExportModal";
import { getUserType } from "../../../assets/helpers";
import { fetchTelecallerBankDashboard } from "../../../store/telecaller/telecallerDashboard";
import { exportFeedbackCasesData } from "../../../assets/api/agency";
import { setQuery } from "../../../store/filters";
import dayjs from "dayjs";
import './CasesFeedback.scss';
const CasesFeedback = () => {
  const { bankDashboard = [], bankDashboard_loading } = useSelector(
    (state) => state?.portfolio
  );
  const navigate = useNavigate();
  const { format } = useSelector(state => state.priceFormat);

  const { query, filter_list } = useSelector((state) => state.filters);
  const { user } = useSelector((state) => state.auth);
  const { tele_bank_dashboard_loading, tele_bank_dashboard } = useSelector(
    (state) => state.telecallerDashboard,
  );

  const { feedback_cases, feedback_cases_loading } = useSelector(
    (state) => state?.telecallerCases
  );

  const buildPortfolios = (data = []) => [
    { label: "All", value: "" },
    ...data.map(({ name, id }) => ({
      label: name,
      value: id,
    })),
  ];

  const telePortfolios = buildPortfolios(tele_bank_dashboard);
  const portfoliosData = filter_list?.find((item) => item?.name === "portfolios")?.filters || [];
  const portfolios = buildPortfolios(portfoliosData);

  const [selectedPortfolio, setSelectedPortfolio] = useState("all");
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [params, setParams] = useState({
    page: 1,
    page_size: 10,
  });
  const [selectedCase, setSelectedCase] = useState(null);
  const [opneFeedbackModal, setOpenFeedbackModal] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const dispatch = useDispatch();

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    return dayjs(dateStr).format("DD MMM YYYY");
  };

  const formattedData = (() => {
    if (feedback_cases_loading) return Array(5).fill({});
    
    // Agency format
    if (feedback_cases?.results?.cases_with_feedback) {
      return feedback_cases.results.cases_with_feedback;
    }
    
    // Telecaller format
    if (feedback_cases?.results?.feedbacks) {
      return feedback_cases.results.feedbacks.map(item => ({
        ...item,
        ...item.case,
        pos: item.case?.odpos || item.case?.pos,
        case_id: item.case?.id
      }));
    }
    
    return [];
  })();


  useEffect(() => {
    dispatch(fetchUserFilters())
    dispatch(fetchBankDashboard())
    dispatch(fetchTelecallerBankDashboard())
  }, [dispatch])

  useEffect(() => {
    dispatch(fetchTelecallerFeedbackCases({ ...params, ...query }))

  }, [dispatch, params, query, refresh])


  const columns = [
    {
      title: 'Loan No.',
      dataIndex: 'loan_no',
      key: 'loan_no',
      render: (text) => feedback_cases_loading ? <Skeleton.Input size="small" active /> : text || "-",
    },
    {
      title: 'Customer Name',
      dataIndex: 'customer_name',
      key: 'customer_name',
      render: (text) => feedback_cases_loading ? <Skeleton.Input size="small" active /> : text || "-",
    },
    {
      title: 'Bank',
      dataIndex: 'bank',
      key: 'bank',
      render: (text) => feedback_cases_loading ? <Skeleton.Input size="small" active /> : text || "-",
    },
    {
      title: 'Product',
      dataIndex: 'product',
      key: 'product',
      render: (text) => feedback_cases_loading ? <Skeleton.Input size="small" active /> : text || "-",
    },
    {
      title: 'Bucket',
      dataIndex: 'bucket',
      key: 'bucket',
      render: (text) => feedback_cases_loading ? <Skeleton.Input size="small" active /> : text || "-",
    },
    {
      title: 'DPD',
      dataIndex: 'dpd',
      key: 'dpd',
      render: (text) => feedback_cases_loading ? <Skeleton.Input size="small" active /> : text || "-",
    },
    {
      title: 'Amount Overdue',
      dataIndex: 'amount_overdue',
      key: 'amount_overdue',
      render: (text) => feedback_cases_loading ? <Skeleton.Input size="small" active /> : formatCurrency(text, format) || "-",
    },
    {
      title: 'Total Amount Due',
      dataIndex: 'total_amount_due',
      key: 'total_amount_due',
      render: (text) => feedback_cases_loading ? <Skeleton.Input size="small" active /> : text ? formatCurrency(text, format) : "-",
    },
    {
      title: 'POS',
      dataIndex: 'pos',
      key: 'pos',
      render: (text) => feedback_cases_loading ? <Skeleton.Input size="small" active /> : text ? Number(text).toFixed(2) : "-",
    },
    {
      title: 'Tot Prin OS',
      dataIndex: 'tot_prin_os',
      key: 'tot_prin_os',
      render: (text) => feedback_cases_loading ? <Skeleton.Input size="small" active /> : text ? Number(text).toFixed(2) : "-",
    },
    {
      title: 'Disposition',
      dataIndex: 'disposition',
      key: 'disposition',
      render: (text) => feedback_cases_loading ? <Skeleton.Input size="small" active /> : text || "-",
    },
    {
      title: 'Comment',
      dataIndex: 'comment',
      key: 'comment',
      render: (text) => feedback_cases_loading ? <Skeleton.Input size="small" active /> : text?.length > 20 ? <Tooltip title={text}>{text?.slice(0, 20) + '...'}</Tooltip> : text || "-",
    },
    {
      title: 'Feedback Date',
      dataIndex: 'date',
      key: 'date',
      render: (text) => feedback_cases_loading ? <Skeleton.Input size="small" active /> : formatDate(text),
    },
    {
      title: 'Phone Number',
      dataIndex: 'phone_number',
      key: 'phone_number',
      render: (text) => feedback_cases_loading ? <Skeleton.Input size="small" active /> : text || "-",
    },
    {
      title: 'Notes',
      dataIndex: 'notes',
      key: 'notes',
      render: (text) => feedback_cases_loading ? <Skeleton.Input size="small" active /> : text?.length > 20 ? <Tooltip title={text}>{text?.slice(0, 20) + '...'}</Tooltip> : text || "-",
    },
    {
      title: 'Paid Amount',
      dataIndex: 'paid_amount',
      key: 'paid_amount',
      render: (text) => feedback_cases_loading ? <Skeleton.Input size="small" active /> : text ? formatCurrency(text, format) : "-",
    },
    {
      title: 'PTP Amount',
      dataIndex: 'ptp_amount',
      key: 'ptp_amount',
      render: (text) => feedback_cases_loading ? <Skeleton.Input size="small" active /> : text ? formatCurrency(text, format) : "-",
    },
    {
      title: 'PTP Date Time',
      dataIndex: 'ptp_date_time',
      key: 'ptp_date_time',
      render: (text) => feedback_cases_loading ? <Skeleton.Input size="small" active /> : formatDate(text),
    },
    {
      title: 'Callback Date Time',
      dataIndex: 'callback_date_time',
      key: 'callback_date_time',
      render: (text) => feedback_cases_loading ? <Skeleton.Input size="small" active /> : formatDate(text),
    },
    {
      title: 'Telecaller',
      dataIndex: 'telecaller',
      key: 'telecaller',
      render: (text) => feedback_cases_loading ? <Skeleton.Input size="small" active /> : text || "-",
    },
    {
      title: 'Supervisor',
      dataIndex: 'supervisor',
      key: 'supervisor',
      render: (text) => feedback_cases_loading ? <Skeleton.Input size="small" active /> : text || "-",
    },
    {
      title: 'Team Lead',
      dataIndex: 'team_lead',
      key: 'team_lead',
      render: (text) => feedback_cases_loading ? <Skeleton.Input size="small" active /> : text || "-",
    },
    {
      title: 'Field Agent',
      dataIndex: 'field_agent',
      key: 'field_agent',
      render: (text) => feedback_cases_loading ? <Skeleton.Input size="small" active /> : text || "-",
    },
    // {
    //   title: 'Action',
    //   dataIndex: 'action',
    //   key: 'action',
    //   render: (_, record) => (
    //     <Button
    //       onClick={(e) => {
    //         e.stopPropagation();
    //         setOpenFeedbackModal(true);
    //         setSelectedCase(record);
    //       }}
    //     >
    //       Feedback
    //     </Button>
    //   )
    // }
  ];

  const onRowClick = (record) => {
    navigate(`/allocation/cases/customer-details/${record?.customer_name}`, {
      state: record,
    });
  }

  return <div className="allocationPage">
    <Flex className="allocationContent cases-feedback-page">
      <Flex
        className="all-buttons"
        gap={15}
        justify="space-between"
        align="center"
        style={{ marginBottom: '20px' }}
      >

        <Input
          placeholder="Search"
          allowClear
          className="searchInput"
          style={{ width: '30%' }}
          onChange={(e) => {
            if (!e.target.value) {
              setParams((prev) => ({
                ...prev,
                search: "",
                page: 1,
                page_size: 10,
              }));
            }
          }}
          onPressEnter={(e) => {
            const value = e.target.value;
            setParams((prev) => ({
              ...prev,
              search: value,
              page: 1,
              page_size: 10,
            }));
          }}
        />

        <Flex gap={10}>
          <Button
            className="exportButton"
            style={{ height: "42px", fontWeight: 500 }}
            onClick={() => setExportModalOpen(true)}
          >
            Export
          </Button>
          <AllocationFilter />
          <CustomFilterDropdown
            buttonLabel="Portfolio"
            options={getUserType(user) === "telecaller" ? telePortfolios : portfolios}
            value={selectedPortfolio}
            defaultValue="all"
            onChange={(val) => {
              setParams((prev) => ({
                ...prev,
                portfolio: val,
                page: 1,
                page_size: 10,
              }));
              setSelectedPortfolio(val);
              dispatch(setQuery({ portfolio: val }));
            }}
          />
        </Flex>
      </Flex>
      <ReusableTable
        columns={columns}
        dataSource={formattedData}
        totalItems={feedback_cases?.count || 0}
        onRowClick={onRowClick}
        pointer={true}
        CurrentPageNo={params.page}
        pageSize={params.page_size}
        triggerChange={(page, size) => {
          setParams((prev) => ({
            ...prev,
            page: page,
            page_size: size,
          }));
        }}
      />

    </Flex>
    <CasesFeedbackModal
      open={opneFeedbackModal}
      setOpen={setOpenFeedbackModal}
      setRefresh={setRefresh}
      data={{
        ...selectedCase,
        id: selectedCase?.case_id
      }}
    />
    <ExportModal open={exportModalOpen} onClose={() => setExportModalOpen(false)} exportFunction={exportFeedbackCasesData} />
  </div>;
};
export default CasesFeedback;